import http from '@/utils/http'

export function getProfile(){
  return  http('/profile')
}

export function putProfile(data){
    return  http.put('/profile',data)
}

export function searchUser(params){
    return  http('/users',{params})
}

